module.exports = __webpack_public_path__ + "img/l1.4e551dc5.png";